import { VSelect } from 'vuetify/lib/components/VSelect';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VSelect,_vm._b({attrs:{"items":_vm.targets,"item-text":function (item) { return item.name; },"item-value":"code","label":_vm.$t('Discount Target'),"outlined":"","hide-details":"auto"},model:{value:(_vm.target),callback:function ($$v) {_vm.target=$$v},expression:"target"}},'v-select',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }